import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import toast from "react-hot-toast";


/* ─────────────────────────────────────────────────────────
   Yardımcılar
───────────────────────────────────────────────────────── */
const dogrulandiMi = (tarih) => !!tarih;

const BadgeDogrulandi = () => (
    <span style={badge.ok} title="Doğrulandı">✅ Doğrulandı</span>
);
const BadgeDogrulanmadi = () => (
    <span style={badge.warn} title="Doğrulanmadı">⚠️ Doğrulanmadı</span>
);

/* ─────────────────────────────────────────────────────────
   Ana Bileşen
───────────────────────────────────────────────────────── */
export default function KullaniciBilgileri() {
    // ── Veri durumları ──────────────────────────────────
    const [authUser,  setAuthUser]  = useState(null);   // supabase.auth.getUser()
    const [profile,   setProfile]   = useState(null);   // profiles tablosu
    const [yukleniyor, setYukleniyor] = useState(true);

    // ── Ad-Soyad düzenleme ──────────────────────────────
    const [adDuzenle, setAdDuzenle]   = useState(false);
    const [yeniAd,    setYeniAd]      = useState("");
    const [adKaydediyor, setAdKaydediyor] = useState(false);

    // ── E-mail düzenleme ────────────────────────────────
    const [emailDuzenle, setEmailDuzenle]     = useState(false);
    const [yeniEmail,    setYeniEmail]         = useState("");
    const [emailKaydediyor, setEmailKaydediyor] = useState(false);
    const [emailDogrulamaGonderildi, setEmailDogrulamaGonderildi] = useState(false);

    // ── Telefon düzenleme ───────────────────────────────
    const [telDuzenle,    setTelDuzenle]    = useState(false);
    const [yeniTel,       setYeniTel]       = useState("");
    const [telKaydediyor, setTelKaydediyor] = useState(false);
    const [otpBekliyor,   setOtpBekliyor]   = useState(false);  // OTP giriş modu
    const [otpKod,        setOtpKod]        = useState("");
    const [otpDogruluyor, setOtpDogruluyor] = useState(false);

    // ── Yeniden doğrulama ───────────────────────────────
    const [emailResendYukleniyor, setEmailResendYukleniyor] = useState(false);
    const [telResendYukleniyor,   setTelResendYukleniyor]   = useState(false);

    /* ── Veri yükle ────────────────────────────────────── */
    const yukle = async () => {
        setYukleniyor(true);
        try {
            const { data: { user }, error: authErr } = await supabase.auth.getUser();
            if (authErr || !user) throw authErr;
            setAuthUser(user);

            const { data: prof, error: profErr } = await supabase
                .from("profiles")
                .select("*")
                .eq("id", user.id)
                .single();
            if (profErr) throw profErr;
            setProfile(prof);
        } catch (e) {
            toast.error("Bilgiler yüklenemedi: " + e?.message);
        }
        setYukleniyor(false);
    };

    useEffect(() => { yukle(); }, []);

    /* ─────────────────────────────────────────────────────
       Ad-Soyad Kaydet
    ───────────────────────────────────────────────────── */
    const adKaydet = async () => {
        if (!yeniAd.trim()) return toast.error("Ad-Soyad boş bırakılamaz");
        setAdKaydediyor(true);
        const { error } = await supabase
            .from("profiles")
            .update({ full_name: yeniAd.trim() })
            .eq("id", authUser.id);
        if (error) {
            toast.error("Güncelleme başarısız: " + error.message);
        } else {
            setProfile(p => ({ ...p, full_name: yeniAd.trim() }));
            setAdDuzenle(false);
            toast.success("Ad-Soyad güncellendi ✅");
        }
        setAdKaydediyor(false);
    };

    /* ─────────────────────────────────────────────────────
       E-mail Değiştir  (Supabase → yeni adrese onay maili)
    ───────────────────────────────────────────────────── */
    const emailKaydet = async () => {
        if (!yeniEmail.trim()) return toast.error("E-mail boş bırakılamaz");
        if (yeniEmail === authUser.email) return toast.error("Yeni e-mail mevcut ile aynı");
        setEmailKaydediyor(true);
        const { error } = await supabase.auth.updateUser({ email: yeniEmail.trim() });
        if (error) {
            toast.error("E-mail güncellenemedi: " + error.message);
        } else {
            setEmailDogrulamaGonderildi(true);
            setEmailDuzenle(false);
            toast.success("Onay maili gönderildi! Yeni adresinizi doğrulayın.");
        }
        setEmailKaydediyor(false);
    };

    /* ─────────────────────────────────────────────────────
       Mevcut E-mail için Doğrulama Maili Yeniden Gönder
    ───────────────────────────────────────────────────── */
    const emailDogrulamaYolla = async () => {
        setEmailResendYukleniyor(true);
        const { error } = await supabase.auth.resend({
            type: "signup",
            email: authUser.email,
        });
        if (error) {
            toast.error("Mail gönderilemedi: " + error.message);
        } else {
            toast.success("Doğrulama maili tekrar gönderildi 📧");
        }
        setEmailResendYukleniyor(false);
    };

    /* ─────────────────────────────────────────────────────
       Telefon Değiştir  (OTP akışı)
    ───────────────────────────────────────────────────── */
    const telKaydet = async () => {
        const tel = yeniTel.trim();
        if (!tel) return toast.error("Telefon boş bırakılamaz");
        setTelKaydediyor(true);
        // Önce profiles tablosunu güncelle (telefon SMS doğrulaması opsiyonel)
        const { error: profErr } = await supabase
            .from("profiles")
            .update({ phone: tel })
            .eq("id", authUser.id);

        if (profErr) {
            toast.error("Telefon güncellenemedi: " + profErr.message);
            setTelKaydediyor(false);
            return;
        }

        // Eğer Supabase SMS sağlayıcısı aktifse auth üzerinden OTP gönder
        const { error: authErr } = await supabase.auth.updateUser({ phone: tel });
        if (authErr) {
            // SMS sağlayıcısı yoksa sadece profiles güncellendi
            setProfile(p => ({ ...p, phone: tel }));
            setTelDuzenle(false);
            toast.success("Telefon güncellendi ✅");
        } else {
            setOtpBekliyor(true);
            toast.success("OTP kodu gönderildi 📱 Lütfen kodu girin");
        }
        setTelKaydediyor(false);
    };

    /* ─────────────────────────────────────────────────────
       OTP Doğrula
    ───────────────────────────────────────────────────── */
    const otpDogrula = async () => {
        if (otpKod.length < 4) return toast.error("Geçerli bir kod girin");
        setOtpDogruluyor(true);
        const { error } = await supabase.auth.verifyOtp({
            phone: yeniTel.trim(),
            token: otpKod.trim(),
            type: "phone_change",
        });
        if (error) {
            toast.error("Kod hatalı: " + error.message);
        } else {
            setProfile(p => ({ ...p, phone: yeniTel.trim() }));
            await yukle();   // auth user'ı yenile
            setOtpBekliyor(false);
            setTelDuzenle(false);
            setOtpKod("");
            toast.success("Telefon doğrulandı ✅");
        }
        setOtpDogruluyor(false);
    };

    /* ─────────────────────────────────────────────────────
       Mevcut Telefon için Doğrulama OTP Yeniden Gönder
    ───────────────────────────────────────────────────── */
    const telDogrulamaYolla = async () => {
        setTelResendYukleniyor(true);
        const { error } = await supabase.auth.resend({
            type: "sms",
            phone: authUser.phone || profile?.phone,
        });
        if (error) {
            toast.error("OTP gönderilemedi: " + error.message);
        } else {
            setOtpBekliyor(true);
            setYeniTel(authUser.phone || profile?.phone || "");
            toast.success("Doğrulama kodu gönderildi 📱");
        }
        setTelResendYukleniyor(false);
    };

    /* ─────────────────────────────────────────────────────
       İptal Yardımcıları
    ───────────────────────────────────────────────────── */
    const adIptal   = () => { setAdDuzenle(false); setYeniAd(""); };
    const emailIptal = () => { setEmailDuzenle(false); setYeniEmail(""); setEmailDogrulamaGonderildi(false); };
    const telIptal  = () => { setTelDuzenle(false); setYeniTel(""); setOtpBekliyor(false); setOtpKod(""); };

    /* ─────────────────────────────────────────────────────
       Yükleniyor
    ───────────────────────────────────────────────────── */
    if (yukleniyor) return (
        <div style={styles.sayfa}>
            <div style={styles.kart}>
                <div style={styles.yukleniyor}>⏳ Bilgiler yükleniyor...</div>
            </div>
        </div>
    );

    const emailOk = dogrulandiMi(authUser?.email_confirmed_at);
    const telOk   = dogrulandiMi(authUser?.phone_confirmed_at);
    const mevcutTel = profile?.phone || authUser?.phone || "";

    /* ─────────────────────────────────────────────────────
       Render
    ───────────────────────────────────────────────────── */
    return (
        <div style={styles.sayfa}>
            <div style={styles.kart}>
                <h2 style={styles.baslik}>👤 Kullanıcı Bilgileri</h2>
                <p style={styles.altBaslik}>Hesap bilgilerinizi görüntüleyebilir ve güncelleyebilirsiniz.</p>

                <div style={styles.bolumler}>

                    {/* ── Ad-Soyad ──────────────────────────────── */}
                    <div style={styles.satir}>
                        <div style={styles.etiketSatir}>
                            <span style={styles.etiket}>Ad – Soyad</span>
                        </div>
                        {adDuzenle ? (
                            <div style={styles.duzenleSatir}>
                                <input
                                    style={styles.input}
                                    value={yeniAd}
                                    onChange={e => setYeniAd(e.target.value)}
                                    placeholder="Ad Soyad"
                                    autoFocus
                                    onKeyDown={e => e.key === "Enter" && adKaydet()}
                                />
                                <div style={styles.butonGrup}>
                                    <button style={styles.kaydetButon} onClick={adKaydet} disabled={adKaydediyor}>
                                        {adKaydediyor ? "Kaydediliyor..." : "💾 Kaydet"}
                                    </button>
                                    <button style={styles.iptalButon} onClick={adIptal}>İptal</button>
                                </div>
                            </div>
                        ) : (
                            <div style={styles.degerSatir}>
                                <span style={styles.deger}>{profile?.full_name || <em style={{ color: "#9ca3af" }}>Belirtilmemiş</em>}</span>
                                <button style={styles.duzenleButon}
                                    onClick={() => { setAdDuzenle(true); setYeniAd(profile?.full_name || ""); }}>
                                    ✏️ Düzenle
                                </button>
                            </div>
                        )}
                    </div>

                    <div style={styles.ayrac} />

                    {/* ── E-mail ────────────────────────────────── */}
                    <div style={styles.satir}>
                        <div style={styles.etiketSatir}>
                            <span style={styles.etiket}>E-mail Adresi</span>
                            {emailOk ? <BadgeDogrulandi /> : <BadgeDogrulanmadi />}
                        </div>

                        {emailDogrulamaGonderildi && (
                            <div style={styles.bilgiKutu}>
                                📧 <strong>{yeniEmail}</strong> adresine onay maili gönderildi.
                                Lütfen yeni adresinizi doğrulayın. Değişiklik doğrulamadan sonra aktif olur.
                            </div>
                        )}

                        {emailDuzenle ? (
                            <div style={styles.duzenleSatir}>
                                <input
                                    style={styles.input}
                                    type="email"
                                    value={yeniEmail}
                                    onChange={e => setYeniEmail(e.target.value)}
                                    placeholder="Yeni e-mail adresi"
                                    autoFocus
                                    onKeyDown={e => e.key === "Enter" && emailKaydet()}
                                />
                                <div style={styles.uyariKutu}>
                                    ℹ️ Değişiklik için yeni adresinize doğrulama maili gönderilecek.
                                </div>
                                <div style={styles.butonGrup}>
                                    <button style={styles.kaydetButon} onClick={emailKaydet} disabled={emailKaydediyor}>
                                        {emailKaydediyor ? "Gönderiliyor..." : "📧 Doğrulama Gönder"}
                                    </button>
                                    <button style={styles.iptalButon} onClick={emailIptal}>İptal</button>
                                </div>
                            </div>
                        ) : (
                            <div style={styles.degerSatir}>
                                <span style={styles.deger}>{authUser?.email || <em style={{ color: "#9ca3af" }}>—</em>}</span>
                                <div style={styles.butonGrup}>
                                    {!emailOk && (
                                        <button
                                            style={styles.dogrulaButon}
                                            onClick={emailDogrulamaYolla}
                                            disabled={emailResendYukleniyor}
                                        >
                                            {emailResendYukleniyor ? "Gönderiliyor..." : "✉️ Doğrulama Maili Gönder"}
                                        </button>
                                    )}
                                    <button style={styles.duzenleButon}
                                        onClick={() => { setEmailDuzenle(true); setYeniEmail(authUser?.email || ""); setEmailDogrulamaGonderildi(false); }}>
                                        ✏️ Değiştir
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    <div style={styles.ayrac} />

                    {/* ── Telefon ───────────────────────────────── */}
                    <div style={styles.satir}>
                        <div style={styles.etiketSatir}>
                            <span style={styles.etiket}>Telefon Numarası</span>
                            {mevcutTel
                                ? (telOk ? <BadgeDogrulandi /> : <BadgeDogrulanmadi />)
                                : <span style={badge.muted}>—</span>
                            }
                        </div>

                        {/* OTP giriş modu */}
                        {otpBekliyor ? (
                            <div style={styles.duzenleSatir}>
                                <div style={styles.bilgiKutu}>
                                    📱 <strong>{yeniTel}</strong> numarasına OTP kodu gönderildi.
                                </div>
                                <input
                                    style={{ ...styles.input, letterSpacing: "4px", fontSize: "20px", textAlign: "center" }}
                                    value={otpKod}
                                    onChange={e => setOtpKod(e.target.value.replace(/\D/g, ""))}
                                    placeholder="_ _ _ _ _ _"
                                    maxLength={6}
                                    autoFocus
                                    onKeyDown={e => e.key === "Enter" && otpDogrula()}
                                />
                                <div style={styles.butonGrup}>
                                    <button style={styles.kaydetButon} onClick={otpDogrula} disabled={otpDogruluyor}>
                                        {otpDogruluyor ? "Doğrulanıyor..." : "✅ Kodu Doğrula"}
                                    </button>
                                    <button style={styles.iptalButon} onClick={telIptal}>İptal</button>
                                </div>
                            </div>
                        ) : telDuzenle ? (
                            <div style={styles.duzenleSatir}>
                                <input
                                    style={styles.input}
                                    type="tel"
                                    value={yeniTel}
                                    onChange={e => setYeniTel(e.target.value)}
                                    placeholder="05xx xxx xx xx"
                                    autoFocus
                                    onKeyDown={e => e.key === "Enter" && telKaydet()}
                                />
                                <div style={styles.uyariKutu}>
                                    ℹ️ Numaranız SMS ile doğrulanacak (SMS sağlayıcısı aktifse).
                                </div>
                                <div style={styles.butonGrup}>
                                    <button style={styles.kaydetButon} onClick={telKaydet} disabled={telKaydediyor}>
                                        {telKaydediyor ? "Kaydediliyor..." : "💾 Kaydet"}
                                    </button>
                                    <button style={styles.iptalButon} onClick={telIptal}>İptal</button>
                                </div>
                            </div>
                        ) : (
                            <div style={styles.degerSatir}>
                                <span style={styles.deger}>
                                    {mevcutTel || <em style={{ color: "#9ca3af" }}>Belirtilmemiş</em>}
                                </span>
                                <div style={styles.butonGrup}>
                                    {mevcutTel && !telOk && (
                                        <button
                                            style={styles.dogrulaButon}
                                            onClick={telDogrulamaYolla}
                                            disabled={telResendYukleniyor}
                                        >
                                            {telResendYukleniyor ? "Gönderiliyor..." : "📱 OTP Gönder"}
                                        </button>
                                    )}
                                    <button style={styles.duzenleButon}
                                        onClick={() => { setTelDuzenle(true); setYeniTel(mevcutTel); }}>
                                        ✏️ {mevcutTel ? "Değiştir" : "Ekle"}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    <div style={styles.ayrac} />

                    {/* ── Hesap Bilgileri (salt okunur) ────────── */}
                    <div style={styles.satir}>
                        <div style={styles.etiketSatir}>
                            <span style={styles.etiket}>Hesap Tipi</span>
                        </div>
                        <div style={styles.degerSatir}>
                            <span style={{ ...styles.deger, textTransform: "capitalize" }}>
                                {profile?.role || "free"}
                            </span>
                        </div>
                    </div>

                    <div style={styles.ayrac} />

                    <div style={styles.satir}>
                        <div style={styles.etiketSatir}>
                            <span style={styles.etiket}>Üyelik Tarihi</span>
                        </div>
                        <div style={styles.degerSatir}>
                            <span style={styles.deger}>
                                {authUser?.created_at
                                    ? new Date(authUser.created_at).toLocaleDateString("tr-TR", {
                                        day: "2-digit", month: "long", year: "numeric"
                                      })
                                    : "—"}
                            </span>
                        </div>
                    </div>

                </div>{/* /bolumler */}
            </div>
        </div>
    );
}

/* ─────────────────────────────────────────────────────────
   Stiller
───────────────────────────────────────────────────────── */
const badge = {
    ok:   { fontSize: "12px", background: "#dcfce7", color: "#16a34a", padding: "2px 8px", borderRadius: "12px", fontWeight: "600" },
    warn: { fontSize: "12px", background: "#fef9c3", color: "#92400e", padding: "2px 8px", borderRadius: "12px", fontWeight: "600" },
    muted:{ fontSize: "12px", color: "#9ca3af" },
};

const styles = {
    sayfa: {
        padding: "2rem",
        maxWidth: "700px",
    },
    kart: {
        background: "white",
        borderRadius: "14px",
        padding: "2rem 2.5rem",
        boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
    },
    baslik: {
        margin: "0 0 0.25rem",
        fontSize: "22px",
        color: "#1e3a5f",
    },
    altBaslik: {
        margin: "0 0 2rem",
        color: "#6b7280",
        fontSize: "14px",
    },
    bolumler: {
        display: "flex",
        flexDirection: "column",
    },
    satir: {
        padding: "1rem 0",
    },
    etiketSatir: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        marginBottom: "0.5rem",
    },
    etiket: {
        fontSize: "12px",
        fontWeight: "700",
        color: "#6b7280",
        letterSpacing: "0.05em",
    },
    degerSatir: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "1rem",
        flexWrap: "wrap",
    },
    deger: {
        fontSize: "15px",
        color: "#111827",
        fontWeight: "500",
    },
    duzenleSatir: {
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
    },
    input: {
        width: "100%",
        padding: "0.65rem 0.9rem",
        border: "1.5px solid #93c5fd",
        borderRadius: "8px",
        fontSize: "15px",
        outline: "none",
        boxSizing: "border-box",
        color: "#111827",
    },
    butonGrup: {
        display: "flex",
        gap: "0.5rem",
        flexWrap: "wrap",
    },
    duzenleButon: {
        padding: "6px 14px",
        fontSize: "13px",
        border: "1px solid #d1d5db",
        borderRadius: "8px",
        background: "white",
        color: "#374151",
        cursor: "pointer",
        whiteSpace: "nowrap",
    },
    dogrulaButon: {
        padding: "6px 14px",
        fontSize: "13px",
        border: "1px solid #fbbf24",
        borderRadius: "8px",
        background: "#fef3c7",
        color: "#92400e",
        cursor: "pointer",
        fontWeight: "600",
        whiteSpace: "nowrap",
    },
    kaydetButon: {
        padding: "7px 16px",
        fontSize: "13px",
        border: "none",
        borderRadius: "8px",
        background: "#2563eb",
        color: "white",
        cursor: "pointer",
        fontWeight: "600",
        whiteSpace: "nowrap",
    },
    iptalButon: {
        padding: "7px 14px",
        fontSize: "13px",
        border: "1px solid #d1d5db",
        borderRadius: "8px",
        background: "white",
        color: "#6b7280",
        cursor: "pointer",
    },
    ayrac: {
        height: "1px",
        background: "#f3f4f6",
    },
    bilgiKutu: {
        background: "#eff6ff",
        border: "1px solid #bfdbfe",
        borderRadius: "8px",
        padding: "0.6rem 0.9rem",
        fontSize: "13px",
        color: "#1e40af",
        lineHeight: "1.5",
    },
    uyariKutu: {
        background: "#f9fafb",
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        padding: "0.5rem 0.9rem",
        fontSize: "12px",
        color: "#6b7280",
    },
    yukleniyor: {
        textAlign: "center",
        padding: "3rem",
        color: "#6b7280",
        fontSize: "16px",
    },
};
